export const canUseMParticle = () => {
  return !!window.mParticle;
}

// https://docs.rokt.com/developers/integration-guides/getting-started/ecommerce/ecommerce-sdk-integration/#5-show-a-placement
export const mParticleSelectPlacements = async (identifier, attributes) => {
  let result = null;
  if (canUseMParticle()) {
    try {

      if (attributes?.amount === 0) {
        attributes.paymenttype = 'free';
      }

      window.mParticle.ready(async () => {
        result = await window.mParticle.Rokt.selectPlacements({
          identifier,
          attributes,
        });
      });
    } catch (err) {
      console.log("Error initializing Rokt placement: " + err);
    }
  }
  return result;
}

// https://docs.rokt.com/developers/integration-guides/getting-started/ecommerce/ecommerce-sdk-integration/#2-identify-the-user
export const mParticleIdentifyUser = async email => {
  if (canUseMParticle()) {
    try {
      await window.mParticle.Identity.identify({
        userIdentities: {
          email
        }
      });
    } catch (err) {
      console.log("Error identifying user to Rokt: " + err);
    }
  }
}

// https://docs.rokt.com/developers/integration-guides/getting-started/ecommerce/ecommerce-sdk-integration/#track-page-views
export const mParticleLogPageView = async page => {
  if (canUseMParticle()) {
    try {
      await window.mParticle.logPageView(
        "page view",
        {
            "screen_name": page,
            "url": window.location.toString(),
            "referring-page": document.referrer
        }
    );
    } catch (err) {
      console.log("Error logging page view to Rokt: " + err);
    }
  }
}
